import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeMessage, selectAllMessages } from '../../../app/store/notifications';

interface Notification {
  id: number;
  type: string;
  message: string;
}

const typeStyles: Record<string, string> = {
  success: 'bg-green-50 border-green-400 text-green-800',
  error: 'bg-red-50 border-red-400 text-red-800',
  warning: 'bg-yellow-50 border-yellow-400 text-yellow-800',
  info: 'bg-blue-50 border-blue-400 text-blue-800',
};

const typeIcons: Record<string, string> = {
  success: '✓',
  error: '✕',
  warning: '⚠',
  info: 'ℹ',
};

const Toast = ({ message }: { message: Notification }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(removeMessage(message.id));
    }, 2000);
    return () => clearTimeout(timer);
  }, [dispatch, message]);

  const style = typeStyles[message.type] || typeStyles.info;
  const icon = typeIcons[message.type] || typeIcons.info;

  return (
    <div className={`flex items-center gap-2 px-4 py-3 border rounded-lg shadow-md ${style}`}>
      <span className="font-bold">{icon}</span>
      <span className="font-medium">{message.message}</span>
    </div>
  );
};

export const MessageToast = () => {
  const messages = useSelector(selectAllMessages) as Notification[];

  return (
    <div className="fixed top-5 right-5 flex flex-col-reverse z-[1000] gap-2">
      {messages.map((message) => (
        <Toast key={message.id} message={message} />
      ))}
    </div>
  );
};
